import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/cuentaSuspendida.css';

export const CuentaSuspendida = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('organizationID');
        localStorage.removeItem('role');
        localStorage.removeItem('authToken');
        navigate('/');
    };

    return (
        <div className='cuentaSuspendida_container'>
            <div className='cuentaSuspendida_subContainer'>
                <h1>Servicio suspendido temporalmente</h1>
                <p>
                    Le informamos que su cuenta ha sido suspendida de forma temporal debido a
                    un adeudo pendiente de pago. Para reactivar su servicio, le agradecemos
                    regularizar su situación a la brevedad posible.
                </p>
                <p>
                    Si ya realizó su pago o considera que esto es un error, por favor póngase
                    en contacto con nuestro equipo de soporte para resolverlo lo antes posible.
                </p>
                <button onClick={handleLogout}>Cerrar sesión</button>
            </div>
        </div>
    );
};
